import { hmac } from '../../shared/hash'
import { Session } from '../session'
import { ConfigBase } from './config'
import { Event, EventType } from './event'
import { EventContext } from './event-context'

interface IServerEvent {
  widgetId?: number
  type: string
  data: any
}

export class ServerEventsConfig extends ConfigBase {
  private events: IServerEvent[] = []

  constructor(private session: Session, private eventsUrl: string, eventTypes?: string[]) {
    super(!!eventsUrl, eventTypes)
  }

  protected getQueue(): (e: Event) => void {
    return (e: Event) => {
      this.events.push({
        type: e.type,
        data: e.getData(),
        ...(e.widget ? { widgetId: e.widget.id } : {}),
      })
    }
  }

  protected async finalize(ctx: EventContext): Promise<void> {
    const events = this.events.filter(
      e => e.type !== EventType.SubmitWidget || Object.keys({ ...e.data, ...ctx.context }).length > 0,
    )

    this.events = []

    if (events.length === 0) {
      return
    }

    const { token = '', timedelta } = await this.session.getServerData()

    const ts = ctx.date + timedelta
    const data = JSON.stringify({ ...ctx, events })
    const sign = hmac(data, `${ts}:${ctx.sessionId}`)

    const url = this.eventsUrl + `?ts=${ts}&sid=${ctx.sessionId}&t=${token}&s=${sign}`

    const sent = window.navigator.sendBeacon?.(url, data)
    if (!sent) {
      await fetch(url, { method: 'POST', body: data })
    }
  }
}
